import { useState, useEffect } from 'react';
import { Theme } from '@/types/enums';

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem('theme') as Theme) || Theme.LIGHT
  );

  useEffect(() => {
    const root = window.document.documentElement;
    
    root.classList.remove(Theme.LIGHT, Theme.DARK);
    root.classList.add(theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  return { theme, setTheme };
}
